const translations = {
    loadingMessage: 'Your Map will be ready shortly...',
    waitingMessage:
        'Don’t have time to wait? Your map will be available in the As Applied Maps page once ready'
};

export default translations;
